

function Impressum() {
  return <div className="main-wrapper">
    
      

      <h2>Impressum</h2>

      <p>
        Solveig Marita Bissinger<br/>
        Heilpraktikerin beschränkt auf das Gebiet der Psychotherapie<br/>
        Jella-Lepman-Straße 22<br/>
        D-81673 München<br/>
        <br/>
        Telefon: <a href="tel:+49 89 43630078">+49 89 43630078</a><br/>
        E-Mail: <a href="mailto:info@tanztherapie-muenchen.de">info@tanztherapie-muenchen.de</a><br/>
      </p>

      <p>
        Die Erlaubnis, die Heilkunde beschränkt auf das Gebiet der Psychotherapie ohne ärztliche Approbation berufsmäßig auszuüben, hat das Gesundheitsreferat der Landeshauptstadt München mit Bescheid vom 07.05.2025 erteilt.
      </p>

      <h3>Aufsichtsbehörde</h3>

      <p>
        Landeshauptstadt München, Referat für Gesundheit und Umwelt<br/>
        Bayerstraße 28A<br/>
        D-80335 München
      </p>

      <h3>Umsatzsteuer</h3>

      <p>
        Die Tätigkeit als Heilpraktikerin ist nach §4 Abs. 14 Umsatzsteuergesetz (UStG) von der Umsatzsteuer befreit.
      </p>

      <p>
        Die Tätigkeit als Leiterin für Kreativen Tanz & Heilsame Bewegung ist nach § 19 Umsatzsteuergesetz (UStG) von der Umsatzsteuer befreit.
      </p>

      <h3>Quellenangaben für die verwendeten Bilder und Grafiken</h3>

      <p>
        Jorma Bissinger<br/>
        Solveig Marita Bissinger<br/>
        Unsplash.com
      </p>

      <h3>Webdesign & Entwicklung</h3>

      <p>
        VUESTE<br/>
        <a href="https://vueste.de" target="_blank" rel="noopener noreferrer">vueste.de</a>
      </p>

      <h3>Haftungsausschluss</h3>

      <p>
        Haftung für Inhalte:<br/>
        Die Inhalte meiner Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehme ich jedoch keine Gewähr.

      </p>

      <p>
        Haftung für Links:<br/>
        Meine Webseite enthält Links zu externen Webseiten Dritter, auf deren Inhalte ich keinen Einfluss habe. Deshalb übernehme ich für diese fremden Inhalte keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
      </p>

    </div>
}
export default Impressum;